const keyLocalStorage = 'chatSilence'

export function getChatSilence(): boolean {
    return !!(localStorage.getItem(keyLocalStorage))
}

export function addChatSilence() : string {
    const instanceSplit = '1'
    localStorage.setItem(keyLocalStorage, instanceSplit)
    return instanceSplit
}

export function remChatSilence() : boolean {
  const instance : string | null = localStorage.getItem(keyLocalStorage)
  if (instance) {
    localStorage.removeItem(keyLocalStorage)
    return true
  }
  return false
}
